import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as _ from 'lodash'
import StripeCheckout from 'react-stripe-checkout'
import { connect } from 'react-redux'
import HelpIcon from 'react-icons/lib/fa/question'
import styled from 'styled-components'

import { Tooltip, Button } from 'wix-style-react'
import { submitNewSubscription } from '../../controllers/payment'
import whimmIcon from '../../assets/whimmIcon.png'
import Card from 'components/shared/Card'
import { DividerHorizontal } from 'components/shared/Divider'
import { BLUE, HELVETICA, GRAY } from 'components/styles'
import Text from 'components/common/Text'

const Title = styled.div`
  color: white;
  font-size: 18px;
  font-weight: 500;
  background-color: ${BLUE};
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
const FlexContainer = styled.div`
  flex: ${props => props.flex ? props.flex : 1};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${HELVETICA};
`
const Price = styled.div`
  font-size: 2em;
  font-weight: 300;
  color: charcoal;
  margin-bottom: 0.5em;
`
const CurrentPlanText = styled.div`
  font-size: 1.5em;
  font-weight: 300;
  color: ${GRAY};
  margin-bottom: 0.5em;
`
const FeatureText = styled.div`
  color: ${GRAY};
  margin-bottom: 0.2em;
  font-size: 0.8em;
`

class PlanInfo extends Component {

  renderTitle () {
    const { plan } = this.props
    return (
      <Title>
        {plan.name}
      </Title>
    )
  }

  renderPrice () {
    const { plan } = this.props
    return <Price>${plan.amount / 100} / {plan.interval}</Price>
  }

  renderTrafficLimit () {
    const { plan } = this.props
    let trafficLimit = 0
    if (_.has(plan, ['metadata', 'trafficLimit'])) trafficLimit = plan.metadata.trafficLimit
    const visitorsTooltipText = `With this plan, your campaigns can drive up to ${trafficLimit} unique visitors every ${plan.interval} to your landing pages. What is a Unique Visitor? Every time a new visitor comes to your landing page, we cookie them to ensure that they see the same variant next time they return. This is a Unique Visitor and they will only count once against your traffic limits each ${plan.interval}. Need more visitors? We can do that.`
    return (
      <Tooltip
        content={visitorsTooltipText}
        shouldCloseOnClickOutside
        placement='bottom'
      >
        <div>
          <Text>Traffic limit</Text>
          <HelpIcon />
        </div>
      </Tooltip>
    )
  }

  handleSubmit = (token) => {
    this.props.dispatch(submitNewSubscription(this.props.plan.id, token))
  }

  renderCheckoutButton () {
    const { isCurrentPlan, plan } = this.props
    if (isCurrentPlan) {
      return <CurrentPlanText> CURRENT PLAN </CurrentPlanText>
    } else {
      return (
        <StripeCheckout
          email={this.props.authData.email}
          allowRememberMe={false}
          ComponentClass={'div'}
          currency={'USD'}
          amount={plan.amount}
          image={whimmIcon}
          description={`PURCHASE ${_.upperCase(plan.name)} PLAN`}
          name={'Whimm'}
          panelLabel={'Purchase'}
          token={this.handleSubmit}
          stripeKey={this.props.references.stripeKey}
        >
          <Button size='large'> Select Plan </Button>
        </StripeCheckout>
      )
    }
  }

  renderFeaturesContent () {
    const { plan } = this.props
    let features = []
    if (_.has(plan, ['metadata', 'features'])) {
      features = JSON.parse(plan.metadata.features)
    }
    return _.map(features, (feature, i) => <FeatureText key={i}>{feature}</FeatureText>)
  }

  renderBaseInfo (plan) {
    let trafficLimit = 0
    if (_.has(plan, ['metadata', 'trafficLimit'])) trafficLimit = plan.metadata.trafficLimit
    return (
      <FlexContainer>
        {this.renderPrice()}
        {this.renderTrafficLimit()}
        <Text>{trafficLimit} unique visitors</Text>
      </FlexContainer>
    )
  }

  render () {
    const { plan } = this.props
    return (
      <Card width='20em' height='30em' styleRaw='background-color: white;'>
        {this.renderTitle()}
        {this.renderBaseInfo(plan)}
        <DividerHorizontal />
        {this.renderFeaturesContent(plan)}
        <DividerHorizontal />
        <FlexContainer>
          {this.renderCheckoutButton()}
        </FlexContainer>
      </Card>
    )
  }
}

PlanInfo.defaultProps = {
  isCurrentPlan: false
}

PlanInfo.propTypes = {
  authData: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  isCurrentPlan: PropTypes.bool,
  references: PropTypes.object.isRequired
}

const mapStateToProps = (state) => (
  {
    authData: state.authData,
    references: state.references
  })

export default connect(mapStateToProps)(PlanInfo)



// WEBPACK FOOTER //
// ./src/components/subscriptions/PlanInfo.js